export enum PerformerType {
  YoungPerformer = "YoungPerformer",
  Graduate = "Graduate",
  Performer = "Performer",
  Filmmakers = "Filmmakers",
}
